import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Spacer from "@ui/spacer/Spacer";
import { Select } from "@ui/select/Select";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { createName } from "src/view/FormParser";
import { S_CLIENT_CREDENTIALS_POPUP } from "src/view/popup/ClientCredentialsPopup";
import { S_CONFIRM } from "src/view/popup/general/ConfirmDialog";
import { S_WEBSITE_REQUEST_POPUP } from "../popup/WebsiteRequestPopup";
import { notify } from "../../../tools/notify";
import { useIsManagerRole, useProjectRoles } from "src/hooks/tools";
import { hasAnyRole, hasRole } from "src/permissions";
import { NestedMerchantList, type NestedMerchant } from "./NestedMerchantList";

export interface IMerchantGroupsProps {
	client_id?: number;
	client_user_id?: number;
	internal?: boolean;
	hideControls?: boolean;
}

const getRequest = (client_id?: number, status?: string) => {
	return {
		method: "merchants/list",
		data: {
			client_id: client_id,
			status: status,
		},
	};
};

export const MerchantGroups = ({ client_id, client_user_id, internal, hideControls }: IMerchantGroupsProps) => {
	useLocale();
	//const router = useRouter();

	//!TODO: statuses;
	const statuses = ["all", "created", "submitted", "aml_review", "rejected", "board_review", "active", "blocked", "deleted"];
	const [selectedStatus, setSelectedStatus] = useState<number>(0);

	// const [showDeleted, setShowDeleted] = useState<boolean>(false);
	const [req, requestMerchants, _resetMerchants, busy] = GD.REQ_API.useRequest(undefined, getRequest(client_id, undefined));

	const roles = useProjectRoles();
	const showFilters = hasAnyRole(roles, ["admin", "aml", "accountant", "support"]);
	const showAdminControls = hasRole(roles, "admin");
	const canAddMerchantWebsite = useIsManagerRole(client_user_id);

	const onAdd = async () => {
		editMerchant(0);
	};

	useEffect(() => {
		requestMerchants(getRequest(client_id, selectedStatus !== 0 ? statuses[selectedStatus] : undefined));

		const id = S_CLIENT_CREDENTIALS_POPUP.subscribe(m => {
			if (m !== null) return;
			requestMerchants(getRequest(client_id, selectedStatus !== 0 ? statuses[selectedStatus] : undefined));
		});
		return () => {
			S_CLIENT_CREDENTIALS_POPUP.unsubscribe(id);
		};
	}, [client_id, selectedStatus]);

	//!TODO:;
	const editMerchant = async (merchantID: number) => {
		client_id && S_WEBSITE_REQUEST_POPUP.invoke({ clientID: client_id, merchantID: merchantID, onSuccess: () => editSuccess() });
	};

	const editSuccess = () => {
		//!TODO:;
		notify.info(msg("success"));

		requestMerchants(getRequest(client_id, selectedStatus !== 0 ? statuses[selectedStatus] : undefined));
	};

	const merchants = req?.data?.filter((val: any) => val.id > 0);
	const openMerchant = (merchant: NestedMerchant) => S_CLIENT_CREDENTIALS_POPUP.invoke({
		merchantID: merchant.id, clienttID: merchant.client_id, client_user_id,
	});
	const deleteMerchant = (merchant: NestedMerchant) => S_CONFIRM.invoke({
		title: msg("deleteWebsite"), message: msg("templateDeleteWebsite_9416fcb0", { v0: merchant.name }), confirm: "Delete", reject: "Cancel",
		onResult: async (value: "confirm" | "reject") => {
			if (value === "confirm") GD.REQ_API.request({ method: "clients/group/delete", data: { client_id: merchant.client_id, group_id: merchant.id } });
		},
	});

	if (internal) return <NestedMerchantList merchants={merchants} busy={busy} error={req?.error}
		onOpen={openMerchant} onDelete={showAdminControls ? deleteMerchant : undefined}
		onRetry={() => requestMerchants(getRequest(client_id, selectedStatus !== 0 ? statuses[selectedStatus] : undefined))} />;

	return <VBox gap="16px">
		<NestedMerchantList variant="standalone" merchants={merchants} busy={busy} error={req?.error}
			onOpen={openMerchant} onDelete={showAdminControls ? deleteMerchant : undefined}
			onRetry={() => requestMerchants(getRequest(client_id, selectedStatus !== 0 ? statuses[selectedStatus] : undefined))}
			filters={showFilters ? <Select size="small" label={msg("status")} sx={{ minWidth: "160px" }}
				values={statuses.map((status, value) => ({ value, name: status === "all" ? msg("allStatuses") : createName(status) }))}
				value={{ value: selectedStatus, name: selectedStatus === 0 ? msg("allStatuses") : createName(statuses[selectedStatus]) }}
				onChange={value => setSelectedStatus(Number(value))} /> : undefined} />
		{!hideControls && canAddMerchantWebsite && <HBox><Spacer grow /><Button onClick={onAdd} title={msg("addMerchantWebsite")} variant="primarySmall" /></HBox>}
	</VBox>;
};
